angular.module('am4').directive('uiSrefActiveIf', function($state) {
    return {
        restrict: 'A',
        scope: {
            uiSrefActiveIfParams: '='
        },
        controller: function($scope, $element, $attrs) {
            var state = $attrs.uiSrefActiveIf;

            function update() {
                if ( $state.includes(state, $scope.uiSrefActiveIfParams) ||
                     $state.is(state, $scope.uiSrefActiveIfParams) ) {
                    $element.addClass($attrs.uiSrefClass);
                } else {
                    $element.removeClass($attrs.uiSrefClass);
                }
            }

            $scope.$on('$stateChangeSuccess', update);
            update();
        }
    };
});



// WEBPACK FOOTER //
// ./src/app/directives/uiSrefActiveIf.js